// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"testimonial_wrapper__2Wi7P","heading":"testimonial_heading__2vluI","text":"testimonial_text__2BmQv"};